module.exports = __webpack_public_path__ + "static/loading-pedro-0c771cc28733bdfeee12b1fedc73bcba.gif";